import { render, staticRenderFns } from "./dialogEditLimits.vue?vue&type=template&id=bffd3764"
import script from "./dialogEditLimits.vue?vue&type=script&lang=js"
export * from "./dialogEditLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports